// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","title":"footer_title__JaZwJ","flex":"footer_flex__y06tN","downloads":"footer_downloads__CPblq","app":"footer_app__vGWRl"};